import { render, staticRenderFns } from "./JmButton.vue?vue&type=template&id=2f34ab93&scoped=true"
import script from "./JmButton.vue?vue&type=script&lang=js"
export * from "./JmButton.vue?vue&type=script&lang=js"
import style0 from "./JmButton.vue?vue&type=style&index=0&id=2f34ab93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f34ab93",
  null
  
)

export default component.exports